export default {
    setDriverActiveJobs (state, jobs) {
        state.driverActiveJobs = jobs
    }
}
